var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{class:_vm.thClass,attrs:{"scope":"col"}})
}
var staticRenderFns = []

export { render, staticRenderFns }